import { MenuItem } from './common';
import {
    ApartmentOutlined,
    AppstoreOutlined,
    BarcodeOutlined,
    ClockCircleOutlined,
    ContactsOutlined,
    DatabaseOutlined,
    EditOutlined,
    FireOutlined,
    GiftOutlined,
    HomeOutlined,
    NotificationOutlined,
    RiseOutlined,
    SettingOutlined,
    ToolOutlined,
    UserOutlined,
} from '@ant-design/icons';

export const SidebarItems: MenuItem[] = [
    {
        id: 1,
        isActive: false,
        title: 'پیشخوان',
        icon: <HomeOutlined />,
        link: '/dashboard/overview',
    },
    {
        id: 35,
        isActive: false,
        title: 'کاربران',
        icon: <UserOutlined />,
        link: '',
        childrens: [
            {
                id: 4,
                title: 'مدیریت کاربران',
                link: '/dashboard/users',
            },
            {
                id: 13,
                title: 'تصاویر مدرک کاربران',
                link: '/dashboard/media-surveys',
            },
            {
                id: 14,
                title: 'مدیریت حساب های بانکی',
                link: '/dashboard/bank-accounts',
            },
            {
                id: 18,
                title: 'جستجوی کاربر با شماره موبایل',
                link: '/dashboard/get-user-by-phone-number',
            },
            {
                id: 19,
                title: 'مدیریت کیف پول های ثبت شده',
                link: '/dashboard/users-saved-wallets',
            },
            {
                id: 36,
                title: 'موجودی کاربران',
                link: '/dashboard/users-balances',
            },
        ],
    },
    {
        id: 5,
        isActive: false,
        title: 'تغییر نرخ',
        icon: <ApartmentOutlined />,
        link: '/dashboard/fiats',
    },
    {
        id: 8,
        isActive: false,
        title: 'اقدامات',
        icon: <ToolOutlined />,
        link: '',
        itemKey: 'waitingForAcceptReceipt',
        childrens: [
            {
                id: 801,
                title: 'خرید',
                link: '/dashboard/orders-transactions/buys-waiting-for-admin',
                itemKey: 'buyWaitingForAcceptReceipt',
            },
            {
                id: 802,
                title: 'فروش',
                link: '/dashboard/orders-transactions/sells-waiting-for-admin',
                itemKey: 'sellWaitingForAcceptReceipt',
            },
            {
                id: 804,
                title: 'برداشت های از کیف پول ریالی در انتظار',
                link: '/dashboard/transactions/irt-withdrawals-waiting-for-admin',
                itemKey: 'irtWithdrawalsWaitingForApprove',
            },
            {
                id: 805,
                title: 'درخواست های احراز هویت در انتظار',
                link: '/dashboard/media-surveys/waiting-for-admin',
                itemKey: 'authMediasWaitingForApprove',
            },
        ],
    },
    {
        id: 7,
        isActive: false,
        title: 'سوابق معامله',
        icon: <ClockCircleOutlined />,
        link: '',
        childrens: [
            {
                id: 701,
                title: 'سفارشات',
                link: '/dashboard/orders',
            },
            {
                id: 702,
                title: 'تراکنش‌ها',
                link: '/dashboard/transactions',
            },
            {
                id: 703,
                title: 'معاملات',
                link: '/dashboard/orders-transactions',
            },
            {
                id: 15,
                title: 'تراکنش های درگاه فعال',
                link: '/dashboard/gateway-transactions',
            },
            {
                id: 16,
                title: 'جستجوی تراکنش درگاه با کد پیگیری',
                link: '/dashboard/search-gateway-transaction-by-tracking-code',
            },
            {
                id: 17,
                title: 'جستجوی سفارش با کد پیگیری',
                link: '/dashboard/search-order-by-tracking-code',
            },
            {
                id: 23,
                title: 'جستجوی سفارش با کلید واژه',
                link: '/dashboard/search-order-by-keyword',
            },
            {
                id: 27,
                title: 'سوابق واریز و برداشت کوکوین',
                link: '/dashboard/kucoin-history',
            },
        ],
    },
    {
        id: 33,
        isActive: false,
        title: 'یوتوپیا',
        icon: <BarcodeOutlined />,
        link: '',
        childrens: [
            {
                id: 2,
                title: 'ووچر های یوتوپیا',
                link: '/dashboard/utopia-vouchers',
            },
            {
                id: 3,
                title: 'استعلام ووچر',
                link: '/dashboard/track-voucher',
            },
            {
                id: 25,
                title: 'شارژ یوتوپیا',
                link: '/dashboard/deposit-utopia',
            },
            {
                id: 37,
                title: 'فروش دستی یوتوپیا',
                link: '/dashboard/sell-utopia-manual',
            },
        ],
    },
    {
        id: 20,
        isActive: false,
        title: 'هش های سوخته',
        link: '/dashboard/old-tx-ids',
        icon: <FireOutlined />,
    },
    {
        id: 34,
        isActive: false,
        title: 'کمپین',
        icon: <GiftOutlined />,
        link: '',
        childrens: [
            {
                id: 26,
                title: 'گزارش کمپین ها',
                link: '/dashboard/campaign-reports',
            },
            {
                id: 29,
                title: 'تیم های برنده جام جهانی',
                link: '/dashboard/world-cup-teams',
            },
            {
                id: 30,
                title: 'شرکت‌کننده‌های جام جهانی',
                link: '/dashboard/world-cup-participants',
            },
            {
                id: 31,
                title: 'تاریخچه امتیازها',
                link: '/dashboard/user-score-logs',
            },
        ],
    },
    {
        id: 28,
        isActive: false,
        title: 'پاپ‌آپ ها',
        icon: <NotificationOutlined />,
        link: '/dashboard/popups',
    },
    {
        id: 39,
        isActive: false,
        title: 'مارکتینگ',
        icon: <RiseOutlined />,
        link: '',
        childrens: [
            {
                id: 3902,
                title: 'تسک‌های تماس',
                link: '/dashboard/marketing/call-tasks',
            },
            {
                id: 3904,
                title: 'پتانسیل ارتقا به طلایی',
                link: '/dashboard/marketing/gold-upgrade',
            },
            {
                id: 3901,
                title: 'اکتیویتی‌ها',
                link: '/dashboard/marketing/activities',
            },
            {
                id: 3903,
                title: 'کمپین‌ها',
                link: '/dashboard/marketing/campaigns',
            },
            {
                id: 38,
                title: 'پیامک گروهی',
                link: '/dashboard/send-bulk-sms',
            },
        ],
    },
    {
        id: 9,
        isActive: false,
        title: 'مدیریت محتوا',
        icon: <EditOutlined />,
        link: '',
        childrens: [
            {
                id: 1901,
                title: 'تاپیک ها',
                link: '/dashboard/content/topics',
            },
            {
                id: 1902,
                title: 'دسته بندی',
                link: '/dashboard/content/categories',
            },
            {
                id: 1903,
                title: 'محتوا',
                link: '/dashboard/content/contents',
            },
            {
                id: 1904,
                title: 'مدیریت ارز ها',
                link: '/dashboard/content/manage-markets',
            },
        ],
    },
    {
        id: 10,
        isActive: false,
        title: 'سود و زیان',
        icon: <DatabaseOutlined />,
        link: '',
        childrens: [
            {
                id: 1001,
                title: 'مدیریت تامین موجودی',
                link: '/dashboard/balancer-transactions',
            },
            {
                id: 1003,
                title: 'گزارش درآمد',
                link: '/dashboard/income-report',
            },
            {
                id: 1004,
                title: 'گزارش موجودی',
                link: '/dashboard/balance-reports',
            },
            {
                id: 1002,
                title: 'گزارشات سود و زیان',
                link: '/dashboard/balancer-transactions/loss-and-profit-report',
            },
        ],
    },
    // {
    //     id: 10,
    //     isActive: false,
    //     title: 'مشاهده واریز های آفلاین',
    //     icon: <ClockCircleOutlined />,
    //     link: '/dashboard/offline-deposit-orders',
    // },
    {
        id: 11,
        isActive: false,
        title: 'همکاران ما',
        icon: <ContactsOutlined />,
        link: '',
        secondaryLinks: ['/dashboard/referral-infos'],
        itemKey: 'referralWithdrawalWaitingForApprove',
        childrens: [
            {
                id: 111,
                title: 'لیست همکاران',
                link: '/dashboard/referral-infos',
            },
            {
                id: 112,
                title: 'لیست درخواست برداشت های رفرال',
                link: '/dashboard/referral-withdrawals',
                itemKey: 'referralWithdrawalWaitingForApprove',
            },
            {
                id: 113,
                title: 'لیست فعالیت همکاران',
                link: '/dashboard/referral-actions',
            },
        ],
    },
    {
        id: 12,
        isActive: false,
        title: 'نقش ها',
        icon: <AppstoreOutlined />,
        link: '/dashboard/roles',
    },
    // {
    //     id: 20,
    //     isActive: false,
    //     title: 'مدیریت شبا های ثبت شده',
    //     icon: <CreditCardOutlined />,
    //     link: '/dashboard/users-saved-ibans',
    // },
    // {
    //     id: 21,
    //     isActive: false,
    //     title: 'ساخت/فعالسازی ووچر',
    //     icon: <CompressOutlined />,
    //     link: '/dashboard/voucher-perfectmoney',
    // },
    // {
    //     id: 22,
    //     isActive: false,
    //     title: 'گزارشات ووچر',
    //     icon: <CompressOutlined />,
    //     link: '/dashboard/voucher-logs',
    // },
    {
        id: 32,
        isActive: false,
        title: 'تنظیمات',
        icon: <SettingOutlined />,
        link: '',
        childrens: [
            {
                id: 24,
                title: 'تنظیمات واریز ریالی',
                link: '/dashboard/deposit-settings',
            },
            {
                id: 3201,
                title: 'درگاه‌های پرداخت',
                link: '/dashboard/settings/payment-gateways',
            },
            {
                id: 3202,
                title: 'تنظیمات مالی و معاملات',
                link: '/dashboard/settings/financial',
            },
            {
                id: 3203,
                title: 'سرویس‌های خارجی',
                link: '/dashboard/settings/integrations',
            },
            {
                id: 3204,
                title: 'احراز هویت',
                link: '/dashboard/settings/authentication',
            },
        ],
    },
];

// منوی موبایل عمداً یک ارجاع به همان SidebarItems است.
// قبلاً یک آرایه‌ی دستیِ جدا بود و به‌مرور از دسکتاپ عقب افتاد:
// «پیشخوان»، «هش های سوخته» و «سود و زیان» اصلاً در آن نبودند و ترتیب هم فرق داشت.
export const MobileItems: MenuItem[] = SidebarItems;
